export const paths = {
  DETAILS: 'details',
  // Is configured in PortalNativeBridge to enable 100% screen brightness on this page
  LOCKER_CODES: 'locker-codes',
  // Is configured in PortalNativeBridge to enable 100% screen brightness on this page
  SP_PICKUP_CODE: 'sp-pickup-code',
  INTERVENTIONS: 'interventions',
  CONFIRMATION: 'confirmation',
  SIGNATURE: 'signature',
  // Is configured in PortalNativeBridge to enable 100% screen brightness on this page
  QRCODE: 'qr-code',
  TRACKTRACE: 'tracktrace',
  CHAT: 'chat',
  // Is configured in PortalNativeBridge to enable 100% screen brightness on this page
  DELIVERY_CODE: 'delivery-code',
  RETURN_SHIPMENT: 'return',
  FIND_YOUR_SERVICEPOINT: 'find-your-servicepoint',
  AGREED_PLACE_PROOF_OF_DELIVERY: 'agreed-place-pod',
}
